import { Collapse } from 'react-collapse';
import React, { useEffect, useState } from 'react';
import { Checkbox } from '@assets/tsx/checkbox';
import { PaginatorButtons } from '@assets/tsx/paginator/buttons';
import ActiveFilters from '../activeFilters/ActiveFilters';
import OutsideAlerter from '../outsideClicker';
import SidebarModal, { SidebarControllers } from '../sidebarModal/SidebarModal';
import { LoadingBox } from '../loadingBox/loadingBox';
import { useI18n } from '@wordpress/react-i18n';
export default function List({ title, page, setPage, filters, checkedFilters: cFilters, onCheckFilters, list, loading, totalPages, onClickPage, itemTemplate }) {
    const [checkedFilters, setCheckedFilters] = useState(cFilters || []);
    const [wrap, setWrap] = useState(null);
    const [toggleMenu, setToggleMenu] = useState(false);
    const openMenu = () => {
        setToggleMenu(true);
    };
    const closeMenu = () => {
        setToggleMenu(false);
    };
    const clearFilters = () => {
        setCheckedFilters([]);
    };
    function getLabels() {
        const filterKeys = Object.keys(filters);
        const labelsArr = filterKeys.map((item) => {
            return filters[`${item}`].attributes;
        });
        let test = [];
        for (let i = 0; i < labelsArr.length; i++) {
            test = [...test, ...labelsArr[i]];
        }
        return {
            terms: {
                nodes: test
            }
        };
    }
    const labels = getLabels();
    useEffect(() => {
        onCheckFilters(checkedFilters);
    }, [checkedFilters]);
    const hasFilters = Object.keys(filters).length > 0;
    return (React.createElement("div", { className: "ltg-list ltg-list-tablet-layout", ref: setWrap },
        React.createElement("div", { className: 'ltg-list-tablet' },
            (!hasFilters && loading) && (React.createElement(React.Fragment, null,
                React.createElement(LoadingBox, { style: { borderRadius: 3, height: 34, marginBottom: '4rem' } }),
                React.createElement(LoadingBox, { style: { borderRadius: 3, height: 24, marginBottom: 25 } }),
                new Array(4).fill('').map((_, index) => (React.createElement("div", { key: `loader-${index}`, style: { borderRadius: 3, display: 'flex', alignItems: 'center', gap: 16 } },
                    React.createElement(LoadingBox, { style: { borderRadius: 3, height: 24, width: 24, marginBottom: 20 } }),
                    React.createElement(LoadingBox, { style: { borderRadius: 3, height: 10, marginBottom: 20, flexGrow: 1 } })))))),
            hasFilters && React.createElement(Filters, { filters: filters, checkedFilters: checkedFilters, setCheckedFilters: setCheckedFilters, setPage: setPage })),
        hasFilters && React.createElement(ActiveFilters, { filters: checkedFilters, labels: labels, visible: hasFilters, setCheckedFilters: setCheckedFilters, toggleMenu: () => {
                openMenu();
            } }),
        React.createElement(SidebarModal, { open: toggleMenu },
            React.createElement(OutsideAlerter, { className: 'ltg-modal-sidebar-wrap', callback: () => {
                    setToggleMenu(false);
                } },
                React.createElement(SidebarControllers, { isFilters: true, handleCloseMenu: () => {
                        closeMenu();
                    }, handleClearFilters: () => {
                        clearFilters();
                    } }),
                React.createElement("div", null, filters &&
                    React.createElement(Filters, { filters: filters, checkedFilters: checkedFilters, setCheckedFilters: setCheckedFilters })))),
        React.createElement(Content, { wrap: wrap, loading: loading, list: list, totalPages: totalPages, itemTemplate: itemTemplate, onClickPage: onClickPage, title: title, page: page })));
}
;
export function Content(props) {
    const { __ } = useI18n();
    const { title, page, list, wrap, loading, itemTemplate, totalPages, onClickPage } = props;
    const [pageTransition, setPageTransition] = useState(false);
    return (React.createElement("div", { className: `ltg-list-wrap${pageTransition ? ' --page-transition' : ''}` },
        title && (React.createElement("h2", { className: "ltg-list-wrap-heading", role: 'presentation' }, title)),
        list.map(({ node }, index) => {
            if (!node) {
                return null;
            }
            ;
            return itemTemplate(node, index);
        }),
        (!loading && (list === null || list === void 0 ? void 0 : list.length) === 0) && (React.createElement("h1", { className: "text-center", role: 'presentation' }, __("Įrašų nėra", 'ltg-widgets'))),
        totalPages > 1 && (React.createElement("div", { className: "ltg-list-pagination" },
            React.createElement(PaginatorButtons, { total: totalPages, page: page, onClick: (page) => {
                    if (wrap) {
                        setPageTransition(true);
                    }
                    wrap === null || wrap === void 0 ? void 0 : wrap.scrollIntoView({
                        behavior: 'smooth',
                    });
                    onClickPage && onClickPage(page).then(() => {
                        setPageTransition(false);
                    });
                } })))));
}
export function Filters({ filters, checkedFilters, setPage, setCheckedFilters, children }) {
    if (!filters)
        return null;
    const { __ } = useI18n();
    const [collapsed, setCollapsed] = useState([]);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "ltg-list-filters" },
            React.createElement("h2", { className: "ltg-list-filters-heading", role: 'presentation' }, __("Filtras", 'ltg-widgets')),
            React.createElement("div", { className: "ltg-list-filters-content" },
                children,
                Object.keys(filters).map((key, index) => {
                    const { label, attributes, sortOrder: order } = filters[key];
                    return (React.createElement("div", { className: 'ltg-list-filter-wrap', style: { order }, key: key },
                        React.createElement(CollapseToggle, { title: label, onToggle: (id) => {
                                setCollapsed(collapsed.includes(id) ?
                                    collapsed.filter(c => c !== id) :
                                    [...collapsed, id]);
                            }, collapsed: collapsed.includes(index), id: index }),
                        React.createElement(Collapse, { isOpened: !collapsed.includes(index) },
                            React.createElement(NestedAttributes, { attributes: attributes, checked: checkedFilters, onChange: (id) => {
                                    setPage && setPage(0);
                                    setCheckedFilters((prev) => (prev.includes(id) ?
                                        prev.filter(i => i !== id) :
                                        [...prev, id]));
                                } }))));
                })))));
}
function CollapseToggle({ title, onToggle, id, collapsed }) {
    return React.createElement("div", { className: `ltg-list-collapse-toggle${collapsed ? ' --collapsed' : ''}`, onClick: () => { onToggle(id); } },
        React.createElement("h4", { className: 'ltg-list-collapse-toggle-title', role: 'presentation' }, title));
}
function NestedAttributes({ attributes, onChange, checked }) {
    return (React.createElement(React.Fragment, null, attributes.map((attr) => {
        var _a;
        return (React.createElement("div", { className: "ltg-list-filter-item-wrap", key: attr.id },
            React.createElement("div", { className: "ltg-list-filter-item" },
                React.createElement(Checkbox, { label: attr.name, checked: checked.includes(attr.databaseId), onChange: () => { onChange && onChange(attr.databaseId); }, id: attr.name + attr.databaseId })),
            ((_a = attr === null || attr === void 0 ? void 0 : attr.children) === null || _a === void 0 ? void 0 : _a.length) > 0 && (React.createElement(NestedAttributes, { attributes: attr.children, checked: checked, onChange: onChange }))));
    })));
}
